import common from '@/scripts/common';

export default {
    map,
    getCategory,
    orderLevels
}
//src\scripts\crossTabulation\crossTabBuilder.js, src\scripts\crossTabulation\reportModelBuilder.js

function map(apiCrossTabulation, parms) {
    const c1index = apiCrossTabulation.controlVariable1.level || 0;
    const c2index = apiCrossTabulation.controlVariable2.level || 0;
    var control = {
        control2Level: getCategory(parms.control2, apiCrossTabulation.controlVariable2.level, 'Total'),
        levelsGroupedByRows: null,
        chiSquare: mapChiSquare(apiCrossTabulation, parms),
        parms: process.env.NODE_ENV === 'development' ? common.shallowClone(parms) : null,
        key: `ct_${c1index}_${c2index}`
    };
    if (apiCrossTabulation.statistics !== undefined && apiCrossTabulation.statistics !== null) {
        var groupedByRowsLevels = mapRows(apiCrossTabulation.statistics, parms);
        control.levelsGroupedByRows = orderLevels(groupedByRowsLevels, 'rowLevel');
    }
    //console.log('control2', control);
    return control;
}

function mapRows(apiStatistics, parms) {
    var rowGroups = common.groupBy(apiStatistics, 'rowVariable', 'level');
    var results = rowGroups.map(v => mapRow(v, parms));
    return results;
}

function mapRow(apiStatistics, parms) {
    var results = {
        rowLevel: getCategory(parms.row, apiStatistics[0].rowVariable.level, 'Total'),
        apiStatistics: apiStatistics,
        columns: mapColumns2(apiStatistics, parms),
        columnStatistics: apiStatistics.filter(s => !s.columnVariable.areAllLevelsIncluded),
        totalStatistics: apiStatistics.filter(s => s.columnVariable.areAllLevelsIncluded)[0]
    };
    return results;
}

function mapColumns2(apiStatistics, parms) {
    var columnGroups = common.groupBy(apiStatistics, 'columnVariable', 'level');
    return columnGroups.map(v => mapColumn2(v, parms));
}

function mapColumn2(apiStatistics, parms) {
    var results = {
        columnLevel: getCategory(parms.column, apiStatistics[0].rowVariable.level, 'Total'),
        apiStatistics: apiStatistics
    };
    return results;
}

function mapChiSquare(crosstabTable, parms, control1Level, control2Level) {
    var minPChisq = 0.0001;
    var significantPValue = 0.05;

    if (!parms.showChiSquare)
        return null;

    var source = crosstabTable.chiSquare;
    if (source === null)
        return null;

    var pValueIsSignificant = crosstabTable.pValue >= 0 && source.pValue <= significantPValue;
    return {
        value: parseFloat(source.value),
        degreesOfFreedom: parseFloat(source.degreesOfFreedom),
        pValue: parseFloat(source.pValue),
        displayPValue: source.pValue >= 0 && source.pValue < minPChisq ? '<' + minPChisq : parseFloat(source.pValue).toFixed(4),
        pIsSignificantClass: pValueIsSignificant ? 'signif_p' : '',
        valueIsNull: source.value === null
    };
}

//---------------------------------------------------------------------------------//
// Shared Methods
//---------------------------------------------------------------------------------//

function orderLevels(records, levelName) {
    //Don't order levels if no need to, or if level wasn't selected
    if (records.length < 2 || records[0][levelName] === null)
        return records;
    var levels = [];
    var totals = [];
    records.forEach(r => (r[levelName].id === 0 ? totals : levels).push(r));

    //Add totals at end
    //totals.forEach(t => levels.push(t));
    //Add totals at beginning
    totals.forEach(t => levels.unshift(t));
    return levels;
}

function getCategory(variableSelection, id, totalDisplayValue) {
    if (variableSelection === null || variableSelection.variableCategories === null || variableSelection.id === null)
        return null;
    var variableCategories = variableSelection.categories;
    //This category may not be selected
    var result = variableCategories.filter(e => e.id === id);
    if (result.length !== 0)
        return result[0];
    else {
        return {
            year: variableCategories[0].year,
            var: variableCategories[0].var,
            id: id,
            title: id === 0 ? totalDisplayValue : 'Don\'t know/refused/missing'
        }
    }
}